<div class="asset-card" [class.asset-card--challenge]="variant === 'challenge'" [class.asset-card--preview]="previewMode" (click)="navigateToDetail()" [style.cursor]="previewMode ? 'default' : (assetType === 'dataset' || assetType === 'model' ? 'pointer' : 'default')">
  <!-- Challenge variant: exact replica of collection card layout -->
  <ng-container *ngIf="variant === 'challenge'">
    <div class="asset-card--content">
      <h3 class="asset-card--title asset-card--title-challenge">{{ data.title }}</h3>

      <div class="asset-card--tag-pill" *ngIf="data.tags && data.tags.length > 0">
        <span>{{ getDisplayTag(data.tags[0]) }}</span>
      </div>
      <div class="asset-card--meta-row">
        <span class="asset-card--meta-format" *ngIf="data.metadata?.format">
          <svg class="asset-card--meta-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>{{ data.metadata?.format }}</span>
        </span>
        <span class="asset-card--meta-dot" *ngIf="data.metadata?.format && data.metadata?.date">•</span>
        <span class="asset-card--meta-date" *ngIf="data.metadata?.date">
          <svg class="asset-card--meta-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <path d="M12 6v6l4 2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span>{{ data.metadata?.date }}</span>
        </span>
        <div class="asset-card--badge-inline" *ngIf="data.badge" [ngClass]="'asset-card--badge-' + (data.badge.color || 'public')">
          <svg class="asset-card--badge-inline-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <path d="M12 6v6l4 2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span>{{ data.badge.label }}</span>
        </div>
      </div>
      <div class="asset-card--divider"></div>
      <div class="asset-card--metrics">
        <span class="asset-card--metric">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
          </svg>
          <span>{{ data.likes ?? 0 }}</span>
        </span>
        <span class="asset-card--metric">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
            <circle cx="12" cy="12" r="3"/>
          </svg>
          <span>{{ data.views ?? 0 }}</span>
        </span>
        <span class="asset-card--metric">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
          <span>{{ data.downloads ?? 0 }}</span>
        </span>
        <button class="asset-card--arrow" aria-label="View details" (click)="navigateToDetail(); $event.stopPropagation()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Default variant -->
  <div class="asset-card--content" *ngIf="variant !== 'challenge'">
    <!-- Title -->
    <h3 class="asset-card--title">{{ data.title }}</h3>

    <!-- Description -->
    <p class="asset-card--description" *ngIf="data.description">
      {{ data.description }}
    </p>

    <!-- Servers / access-type chips -->
    <div class="asset-card--tags" *ngIf="data.tags && data.tags.length > 0">
      <span class="asset-card--chip" *ngFor="let tag of data.tags">{{ getDisplayTag(tag) }}</span>
    </div>

    <!-- Provider/Organisation -->
    <p class="asset-card--provider-link" *ngIf="data.provider || data.organisation">
      {{ data.provider || data.organisation }}
    </p>

    <!-- Inline Meta Row: format icon + dot + date icon + badge (right-aligned) -->
    <div class="asset-card--meta-row asset-card--meta-row-default" *ngIf="data.metadata || data.badge">
      <span class="asset-card--meta-format" *ngIf="data.metadata?.format">
        <svg class="asset-card--meta-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>{{ data.metadata?.format }}</span>
      </span>
      <span class="asset-card--meta-dot" *ngIf="data.metadata?.format && data.metadata?.date">•</span>
      <span class="asset-card--meta-date" *ngIf="data.metadata?.date">
        <svg class="asset-card--meta-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
          <path d="M12 6v6l4 2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <span>{{ data.metadata?.date }}</span>
      </span>
      <div class="asset-card--badge-inline" *ngIf="data.badge" [ngClass]="'asset-card--badge-' + (data.badge.color || 'public')">
        <img src="/public.svg" alt="" class="asset-card--badge-inline-icon" />
        <span>{{ data.badge.label }}</span>
      </div>
    </div>

    <!-- Divider -->
    <div class="asset-card--divider"></div>

    <!-- Metrics Footer -->
    <div class="asset-card--metrics">
      <span class="asset-card--metric">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
        </svg>
        <span>{{ data.likes ?? 0 }}</span>
      </span>
      <span class="asset-card--metric">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
          <circle cx="12" cy="12" r="3"/>
        </svg>
        <span>{{ data.views ?? 0 }}</span>
      </span>
      <span class="asset-card--metric">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="7 10 12 15 17 10"/>
          <line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
        <span>{{ data.downloads ?? 0 }}</span>
      </span>
      <button class="asset-card--arrow" aria-label="View details" (click)="navigateToDetail(); $event.stopPropagation()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>
</div>

